const subscriptionCancelKeys = {
  "subscription.cancel.dialog.title": "Cancel Subscription",
  "subscription.cancel.dialog.confirmation": "Are you sure you want to cancel your subscription?",
  "subscription.cancel.dialog.immediate": "Cancel immediately",
  "subscription.cancel.dialog.immediate.description": "Your subscription will be cancelled immediately and you will lose access to all features.",
  "subscription.cancel.dialog.end-of-period":
    "Your subscription will remain active until the end of your current billing period. You will still have access to all features until then.",
  "subscription.cancel.dialog.active-until": "Your subscription will be active until: {{date}}",
  "subscription.cancel.dialog.button.keep": "Keep Subscription",
  "subscription.cancel.dialog.button.cancel": "Cancel Subscription",
};

const subscriptionCancelSuccessDialog = {
  "subscription.cancel.notification.success.title": "We're sad to see you go",
  "subscription.cancel.notification.success.message": "Your subscription has been successfully canceled. We hope to welcome you back soon!",
  "subscription.cancel.notification.error.title": "Error Canceling Subscription",
  "subscription.cancel.notification.error.message": "An error occurred while canceling your subscription. Please try again.",
};

export const subscriptionCancel = {
  ...subscriptionCancelKeys,
  ...subscriptionCancelSuccessDialog,
};
